<script>
import ExerciseDrawer from '@components/exercise/exercise-drawer.vue';
import ExerciseVideoHeader from '@components/exercise/exercise-video-header.vue';
import ExerciseVideoSubHeader from '@components/exercise/exercise-video-sub-header.vue';
import { workoutComputed, workoutMethods, videoMethods } from '@/src/state/helpers';

export default {
  components: {
    ExerciseDrawer,
    ExerciseVideoHeader,
    ExerciseVideoSubHeader,
  },
  props: {
    videoUrl: {
      type: String,
      required: false,
      default: null,
    },
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...workoutComputed,
    coverPhotoUrl() {
      return !this.videoUrl &&
        this.currentExercise &&
        this.currentExercise.mediaAssets &&
        this.currentExercise.mediaAssets.coverPhoto &&
        this.currentExercise.mediaAssets.coverPhoto.url
        ? this.currentExercise.mediaAssets.coverPhoto.url
        : '';
    },
    hasTabataFitnessType() {
      if (this.currentCircuit.fitness_types) {
        return this.currentCircuit.fitness_types.filter((e) => e.label.toLowerCase() === 'tabata').length > 0;
      } else {
        return false;
      }
    },
    isTabata() {
      if (this.hasTabataFitnessType) {
        return this.currentCircuit.tabata || this.hasTabataFitnessType;
      } else {
        return this.currentCircuit.tabata;
      }
    },
  },
  methods: {
    ...workoutMethods,
    ...videoMethods,
  },
  async mounted() {
    if (this.isTabata && this.currentExerciseIndex === 0 && this.currentCircuitIndex === 0) {
      this.setVideoAction('pause');
      this.setShowCircuitIntro(true);
    }
  },
};
</script>

<template>
  <div
    :style="{ 'background-image': `url(${coverPhotoUrl})` }"
    :class="['video-background-content', { 'with-photo': coverPhotoUrl, transition: isTransitionPeriod || showCircuitIntro }]"
  >
    <div class="video-background-content-headers">
      <ExerciseVideoHeader :workout="workout" />
      <ExerciseVideoSubHeader />
    </div>

    <div class="no-media" v-if="!videoUrl && !coverPhotoUrl">
      <h3>No Video Available</h3>
    </div>

    <div class="no-media" v-if="showCircuitIntro">
      <h2 class="label title">{{ currentExercise.label }}</h2>
    </div>

    <ExerciseDrawer :workout="workout" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.video-background-content {
  align-items: center;
  background-color: rgba(rgb(80, 80, 80), 0.25);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 1;

  &.with-photo::before {
    background-color: rgba(rgb(80, 80, 80), 0.25);
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
  }

  @media screen and (max-width: 1024px) {
    background-position: top center;
    background-size: contain;
  }
  @media screen and (max-width: 790px) {
    background-position: top center;
    background-size: auto 55%;
  }

  .video-background-content-headers {
    width: 100%;
  }

  .label {
    color: white;
    font-family: $roboto;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.5px;
    line-height: 55px;
    text-align: center;
    -webkit-transition-duration: 0.3s;

    @media screen and (min-width: 1100px) {
      @include calc-font-size(1.2);
    }
  }

  .title {
    font-size: 45px;
  }

  .no-media {
    align-items: center;
    display: flex;
    height: 61.3%;
    justify-content: center;
    padding: 3rem 0;
    width: 93%;
  }
}

.transition {
  background-color: black !important;
}
</style>
